import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AxiosInstance from '../../../helpers/AxiosInstance';
import Swal from 'sweetalert2';
import { useEffect, useState } from 'react';

const useForm = () => {
  let history = useHistory();
  let location = useLocation();
  const { t } = useTranslation();
  const [book, setBook] = useState({});
  const [bookFile, setBookFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (location.params && location.params.id) {
      getBook();
      getBookFile();
    } else {
      history.push('/book');
    }
  }, []);

  const back = () => {
    history.goBack();
  };

  const getBookFile = () => {
    setLoading(true);
    AxiosInstance.get('/pdf/' + location.params.id, { responseType: 'arraybuffer' })
      .then((response) => {
        setBookFile(response);
      })
      .catch(() => {
        setError('ERROR_LOADING_PDF');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getBook = () => {
    AxiosInstance.get('/book/' + location.params.id)
      .then((response) => {
        setBook(response.data);
      })
      .catch((error) => {
        Swal.fire(t('book.ERROR_GET_BOOK'), '', 'error');
      });
  };

  return {
    back,
    book,
    bookFile,
    loading,
    error,
    setError,
  };
};

export default useForm;
